<template>
  <div class="transfer-wrapper" @submit.prevent>
    <!-- 头部搜索 -->
    <div class="transfer-header__wrapper">
      <el-form :inline="true" class="filter-form">
        <el-form-item label="未对接系统:">
          <el-select v-model="filter.sysId">
            <el-option label="全部" value=""></el-option>
            <el-option
              v-for="item in sysList"
              :key="item.id"
              :label="item.systemName"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="字段名:">
          <el-input v-model="filter.name"></el-input>
        </el-form-item>

        <el-form-item label="是否必传:">
          <el-select v-model="filter.required" placeholder="请选择类型">
            <el-option label="全部" value=""></el-option>
            <el-option label="是" :value="true"></el-option>
            <el-option label="否" :value="false"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="说明:">
          <el-input v-model="filter.desc"></el-input>
        </el-form-item>

        <el-form-item>
          <el-button @click="$_filter" class="search__btn">查询</el-button>
        </el-form-item>
      </el-form>
      <div class="opera-box">
        <el-button class="select__btn" @click="$_batch()">批量添加</el-button>
        <el-button class="select__btn" @click="$_batch(-1)">批量删除</el-button>
      </div>
    </div>
    <!-- 可选择数据列表 -->
    <div class="table-list__wrapper">
      <el-table
        class="table-list__box"
        ref="tableRef"
        :data="paramsTree"
        v-loading="isLoading"
        select-on-indeterminate
        :height="384"
        stripe
        tooltip-effect="dark"
        @select="rowSelect"
        @select-all="selectAll"
        row-key="uid"
        default-expand-all
        :tree-props="{ children: 'children' }"
      >
        <el-table-column type="selection" width="50"></el-table-column>
        <el-table-column label="序号" type="index" width="50">
        </el-table-column>
        <el-table-column
          v-for="column in columns"
          :key="column.key"
          :prop="column.key"
          :label="column.label"
          :width="column.width"
          sortable
          show-overflow-tooltip
          filter-placement="bottom"
          v-if="!column.component"
        ></el-table-column>
        <el-table-column
          :prop="column.key"
          :label="column.label"
          :width="column.width"
          type=""
          sortable
          v-else
        >
          <template slot-scope="scope">
            <component :is="column.component" :row="scope.row"></component>
          </template>
        </el-table-column>

        <div slot="empty">暂无数据</div>
      </el-table>
    </div>

    <!-- 批量对接 -->
    <modal-batch
      v-if="modal.show && modal.template === 'batch'"
      :title="modal.title"
      :isSubmitPost="false"
      @callback="$_callback"
      @close="$_close"
    ></modal-batch>
  </div>
</template>

<script>
import * as Utils from "@/plugins/utils";
import modalBatch from "./modal-batch";
const columns = [
  { key: "systemDockingInfos", label: "已对接系统", component: "sysTmpl", width: 200 },
  { key: "name", label: "字段名", width: 180 },
  { key: "type", label: "类型", component: "typeTmpl", width: 100 },
  { key: "required", label: "是否必传", component: "requiredTmpl", width: 100 },
  { key: "desc", label: "说明" },
];
export default {
  name: "transfer",
  props: {
    keyList: { type: Array, default: () => [] },
  },
  components: {
    modalBatch,
    sysTmpl: {
      template: `<div class="sys-item">
        <div class="item" v-for="item in row.systemDockingInfos"><img :src="icon(item)" /></div>
      </div>`,
      props: { row: { type: Object, required: true } },
      methods: {
        icon(item){
          return item.dockingFlowType === 1
            ? item.iconOfSendZt
            : item.dockingFlowType === 2
            ? item.iconOfZtPush
            : item.iconOfSendAndPush
        }
      }
    },
    typeTmpl: {
      template: `<span>{{row | typeDesc}}</span>`,
      props: { row: { type: Object, required: true } },
      filters: {
        typeDesc(row) {
          let paramTypes = [
            { value: 0, label: "", size: 0 },
            { value: 1, label: "String", size: 100 },
            { value: 2, label: "Boolean", size: 1 },
            { value: 3, label: "Int", size: 11 },
            { value: 4, label: "Double", size: 32 },
            { value: 5, label: "Long", size: 0 },
            { value: 6, label: "Object", size: 0 },
            { value: 7, label: "Array", size: 0 },
            { value: 9, label: "Date", size: 0 },
            { value: 10, label: "Datetime", size: 0 },
            { value: 11, label: "Float", size: 0 },
          ];
          let type = paramTypes.find((item) => item.value === row.type);

          if (row.type === 7 && row.arrayType !== 0) {
            let arrayType = paramTypes.find(
              (item) => item.value === row.arrayType
            );
            return type.label + `[${arrayType ? arrayType.label : " "}]`;
          }
          return type.label;
        },
      },
    },
    requiredTmpl: {
      template: `<span>{{row.required ? '是':'否'}}</span>`,
      props: { row: { type: Object, required: true } },
    },
  },
  data() {
    return {
      isLoading: false,
      searchKey: "",
      columns,
      dataList: [],
      sysList: [],
      paramsTree: [],
      filter: {
        sysId: "",
        name: "",
        required: "",
        desc: "",
      },
      pagination: {
        pageNow: 1,
        pageSize: 20,
        pages: 0,
        total: 0,
      },
      selectedList: [], // 已选择项
      selectFlag: false, //是否全选
      modify: '',//批量操作

      modal: {
        show: false,
        title: "",
        template: "",
        data: {},
      },
    };
  },
  methods: {
    $_filter() {
      this.paramsTree = [...Utils.paramListToTree(this.dataList, true)]; //重置所有数据
      if (
        this.filter.sysId === "" &&
        this.filter.name === "" &&
        this.filter.required === "" &&
        this.filter.desc === ""
      ) {
        return;
      }
      this.search(this.paramsTree);
    },
    search(nodeList) {
      let self = this;
      if (nodeList && nodeList.length > 0) {
        nodeList.forEach((n, i, a) => {
          self.searchEach(n);
        });

        // 没有叶子节点的根节点也要清理掉
        let length = nodeList.length;
        for (let i = length - 1; i >= 0; i--) {
          let e2 = nodeList[i];
          if (!this.isHasChildren(e2) && !this.predicate(e2)) {
            nodeList.splice(i, 1);
          }
        }
      }
    },

    // 对子节点进行搜索。
    searchEach(node) {
      let depth = this.getTreeDepth(node);
      let self = this;
      for (let i = 0; i < depth - 1; i++) {
        // 记录【删除不匹配搜索内容的叶子节点】操作的次数。
        // 如果这个变量记录的操作次数为0，表示树形结构中，所有的
        // 叶子节点(不包含只有根节点的情况)都匹配搜索内容。那么就没有必要再
        // 在循环体里面遍历树了.
        let spliceCounter = 0;

        // 遍历树形结构
        this.traverseTree(node, (n) => {
          if (self.isHasChildren(n)) {
            let children = n.children;
            let length = children.length;

            // 找到不匹配搜索内容的叶子节点并删除。为了避免要删除的元素在数组中的索引改变，从后向前循环,
            // 找到匹配的元素就删除。
            for (let j = length - 1; j >= 0; j--) {
              let e3 = children[j];
              if (!self.isHasChildren(e3) && !self.predicate(e3)) {
                children.splice(j, 1);
                spliceCounter++;
              }
            } // end for (let j = length - 1; j >= 0; j--)
          }
        }); // end this.traverseTree(node, n=>{

        // 所有的叶子节点都匹配搜索内容，没必要再执行循环体了。
        if (spliceCounter == 0) {
          break;
        }
      }
    },
    predicate(x) {
      const filter = this.filter;
      if (
          (~x.name.indexOf(filter.name) || filter.name === "") &&
          (~x.desc.indexOf(filter.desc) || filter.desc === "") &&
          (x.required === filter.required || filter.required === "") &&
          (filter.sysId !== "" &&
            !~x.systemDockingInfos.findIndex(
              (ele) => ele.dockingSystemId === filter.sysId
            ) ||
            filter.sysId === "")
      ) {
        return true;
      }
      return false;
    },
    // 判断树形结构中的一个节点是否具有孩子节点
    isHasChildren(node) {
      let flag = false;
      if (node.children && node.children.length > 0) {
        flag = true;
      }
      return flag;
    },

    // 通过传入根节点获得树的深度，是 calDepth 的调用者。
    getTreeDepth(node) {
      if (undefined == node || null == node) {
        return 0;
      }
      // 返回结果
      let r = 0;
      // 树中当前层节点的集合。
      let currentLevelNodes = [node];
      // 判断当前层是否有节点
      while (currentLevelNodes.length > 0) {
        // 当前层有节点，深度可以加一。
        r++;
        // 下一层节点的集合。
        let nextLevelNodes = new Array();
        // 找到树中所有的下一层节点，并把这些节点放到 nextLevelNodes 中。
        for (let i = 0; i < currentLevelNodes.length; i++) {
          let e = currentLevelNodes[i];
          if (this.isHasChildren(e)) {
            nextLevelNodes = nextLevelNodes.concat(e.children);
          }
        }
        // 令当前层节点集合的引用指向下一层节点的集合。
        currentLevelNodes = nextLevelNodes;
      }
      return r;
    },

    // 非递归遍历树
    traverseTree(node, callback) {
      if (!node) {
        return;
      }
      var stack = [];
      stack.push(node);
      var tmpNode;
      while (stack.length > 0) {
        tmpNode = stack.pop();
        callback(tmpNode);
        if (tmpNode.children && tmpNode.children.length > 0) {
          for (let i = tmpNode.children.length - 1; i >= 0; i--) {
            stack.push(tmpNode.children[i]);
          }
        }
      }
    },

    $_getApis() {
      this.isLoading = true;
      this.$service.post("dockingSystemGetAll").then((result) => {
        this.isLoading = false;
        if (result.$.checkResult(result, true)) {
          this.sysList = result.data.concat([]);
        }
      });
    },
    toggleSelection(rows, flag) {
      if (rows) {
        rows.forEach((row) => {
          this.$refs.tableRef.toggleRowSelection(row, flag);
          if (row.children) {
            this.toggleSelection(row.children, flag);
          }
        });
      }
    },
    rowSelect(selection, row) {
      // 全选 or 取消全选
      if (selection.indexOf(row) > -1) {
        row.select = true;
        if (row.children) {
          this.toggleSelection(row.children, true);
          this.addSelect(row.children, true);
        }
      } else if (selection.indexOf(row) == -1) {
        row.select = false;
        if (row.children) {
          this.toggleSelection(row.children, false);
          this.addSelect(row.children, false);
        }
      }
      this.getParent( row);
    },
    // 获取父节点并操作
    // 当所有子节点取消选中，父节点也要取消选中；当所有子节点已选中，父节点也要相应选中
    getParent(row) {
      // 返回的数据中 节点名称有可能是相同的，所以只能通过 父节点名称 + 自己的节点名称来找到当前点击节点的父节点
      let parentName = row.parent
      const parent = this.dataList.find(item => item.parent + item.name === parentName || item.parent + '.' + item.name === parentName)

      // 如果没有父节点，则跳过，有父节点，则继续递归遍历。
      if(!parent) {
        return
      }else {
        // 判断每个子节点是否都勾选，是则父节点勾选，否则父节点取消勾选
        const isAllSelected = parent.children.every(c => c.select)
        this.$refs.tableRef.toggleRowSelection(parent, isAllSelected);
        parent.select = isAllSelected
        this.getParent(parent)
      }
    },
    selectAll(selection) {
      if (!this.selectFlag) {
        this.toggleSelection(selection, true);
        this.addSelect(this.paramsTree, true);
      } else {
        this.$refs.tableRef.clearSelection();
        this.addSelect(this.paramsTree, false);
      }
      this.selectFlag = !this.selectFlag;
    },
    // 树形表多选，添加select字段区分当前行是否被选中
    // 为了：当所有子节点取消选中，父节点也要取消选中；当所有子节点已选中，父节点也要相应选中
    // element文档貌似没相关操作
    addSelect(data, flag) {
      data.forEach((item, index) => {
        item.select = flag;
        if (data[index].children) {
          this.addSelect(data[index].children, flag);
        }
      });
    },

    // 批量对接
    $_batch(type) {
      //获取已选择的数据
      this.selectedList = this.$refs.tableRef.selection.concat([]);
      if (this.selectedList.length === 0) {
        $MessageBox.alert({ content: "请选择字段!" });
        return false;
      }
      this.modify = type === -1 ? 'del':'add';
      this.modal.show = true;
      this.modal.template = "batch";
      this.modal.title =  type === -1 ? "批量删除对接系统" : "批量添加对接系统";
    },
    $_callback(data) {
      if(data.length){
        this.selectedList.map((item) => {
          //已勾选的字段
          if(this.modify === 'add'){//添加
            let arr = []
            data.map(o => {
              let index = item.systemDockingInfos.findIndex(ele => ele.dockingSystemId === o.dockingSystemId)
              if(!~index){
                arr.push(o)
              }else{//判断当推送不一样的时候，设置为全部
                let itemSys = item.systemDockingInfos[index]
                if(itemSys.dockingFlowType !== o.dockingFlowType){
                  itemSys.dockingFlowType = 3
                }
              }
            })
            item.systemDockingInfos = arr.concat(item.systemDockingInfos)
          }else{//删除
            let arr = []
            item.systemDockingInfos.map((o, i) => {
              let index = data.findIndex(ele => ele.dockingSystemId === o.dockingSystemId)
              if(~index){
                if(data[index].dockingFlowType === o.dockingFlowType){
                  arr.push(o.dockingSystemId)
                }else if(o.dockingFlowType === 3){
                  o.dockingFlowType = data[index].dockingFlowType === 1? 2:1
                }
              }
            })
            item.systemDockingInfos = item.systemDockingInfos.filter(o => !~arr.findIndex(e => e === o.dockingSystemId))
          }
        });
      }
    },
    // 关闭弹窗
    $_close() {
      this.modal.show = false;
      this.modal.template = "";
      this.modal.data = {};
      this.modal.title = "";
    },
  },
  // watch: {
  //   dataList:{
  //     handler(val) {
  //       this.$emit("update:keyList", val);
  //       this.paramsTree = [...Utils.paramListToTree(val, true)];
  //     },
  //     deep: true
  //   }
  // },

  created() {
    this.$_getApis();
    if (this.keyList.length > 0) {
      this.dataList = this.keyList.map((item) => {
        item.select = false;
        if (!item.systemDockingInfos) {
          this.$set(item, "systemDockingInfos", []);
        }
        return item;
      });
      // 参数列表树形结构
      this.paramsTree = [...Utils.paramListToTree(this.dataList, true)];
    }
  },
};
</script>

<style lang="scss" scoped>
.transfer-wrapper {
  &::after {
    content: "";
    display: table;
    clear: both;
  }
  .transfer-header__wrapper {
    position: relative;
    color: #535353;
    background-color: #fff;
    padding: 0 16px;
    .filter-form {
      padding-top: 12px;
      /deep/ .el-form-item {
        margin-bottom: 0;
        .el-input {
          width: 110px;
        }
      }
    }
  }
  .table__empty-text {
    color: #535353;
    padding-top: 100px;
    display: block;
    position: relative;
    background: url(~@/assets/images/icon-mascot.png) no-repeat top center;
  }
  /deep/ .el-table {
    background-color: #fff;
    .el-table__expand-icon {
      display: inline-block;
      width: 20px;
      line-height: 20px;
      height: 20px;
      text-align: center;
      margin-right: 3px;
    }
    .el-table__expand-icon--expanded {
      transform: rotate(90deg);
    }
    .el-table__placeholder {
      display: inline-block;
      width: 20px;
    }
  }
  .opera-box {
    margin-top: 16px;
    padding: 16px 0;
    border-top: 1px solid #eee;
    .select__btn {
      padding: 0 10px;
      height: 30px;
    }
  }
  /deep/ .sys-item {
    .item {
      display: inline-block;
      margin-right: 10px;
      img{
        width: 44px;
      }
    }
  }
}
</style>

